import { CheckCircleIcon } from '@treneo/shared/icons';

import { Alert } from './alert';

type Props = {
  text?: string;
  children?: React.ReactNode;
};

export const AlertSuccess = ({ text, children }: Readonly<Props>) => (
  <Alert severity='success' icon={<CheckCircleIcon />}>
    {children ?? text}
  </Alert>
);
